window.AnchorMenu = {
    $win: $(window),
    $anchorMenuWrapper: $('.anchor-menu-wrapper'),
    $anchorMenuList: $('ul.anchor-links'),
    $anchorMenuInner: $('.anchor-menu-inner'),
    $anchorLinks: undefined,
    $animatingScroll: false,
    $topMenuHeight: 0,
    $scrollItems: undefined,

    init: function () {

        var self = this,
            $body = $('body');

        if (!self.$anchorMenuWrapper.length) {
            return; // No anchor menu on current page
        }

        self.initAnchorLinks();

        if (!self.$anchorLinks) {
            return;
        }

        self.$anchorMenuWrapper.appendTo('.navbar.navbar-fixed-top');

        $body.addClass('anchor-menu-enabled');

        // Set enabled class so that we can handle the navbar height change
        setTimeout(function(){
            $body.addClass('anchor-menu-show');
        }, 150);

        self.$win.resize(function () {
            self.updateAnchorMenuWidth();
        });

        self.updateAnchorMenuWidth();
        self.setActiveAnchor();

        $('#anchor-scroll-arrow').on('click', function () {
            var nextAnchorLink = $('.menu-anchor-link.active + .menu-anchor-link');

            // If already on the last menu item
            if (!nextAnchorLink.length) {
                return;
            }

            var target = $($('a', nextAnchorLink)[0].hash);
            if (target.length) {
                self.$animatingScroll = true;

                // Only prevent default if animation is actually gonna happen
                //event.stopImmediatePropagation()
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 64
                }, 650, function () {
                    self.$anchorLinks.removeClass("active");
                    nextAnchorLink.addClass("active");
                    self.$animatingScroll = false;
                    self.scrollToActiveAnchorMenuItem(nextAnchorLink);
                });
            }
        });
    },

    initAnchorLinks: function () {
        var self = this;

        var anchorTemplate = '<li class="menu-anchor-link"><a href="#{0}">{1}</a></li>',
            anchors = window.AnchorMenu.getAnchors(),
            menuhtml = "";

        if (anchors.length === 0) {
            return;
        }

        $.each(anchors, function (index, value) {
            var anchorHtml = anchorTemplate.format(value.id, value.name);
            menuhtml += anchorHtml;
        });

        $('.anchor-tags').prepend(menuhtml);

        self.$anchorLinks = $('.menu-anchor-link');

        $(document).on('click', '.menu-anchor-link a', function (event) {
            
        });

        var anchorMenu = $(".anchor-menu-wrapper");
        var anchorMenuOffset = anchorMenu.length > 0 ? anchorMenu.height() : 0;

        self.$anchorLinks.click(function (event) {
            var $this = $(this);

            var target = $($('a', $this)[0].hash);
            if (target.length) {
                self.$animatingScroll = true;

                // Only prevent default if animation is actually gonna happen
                //event.stopImmediatePropagation()
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - anchorMenuOffset
                }, 650, function () {
                    self.$anchorLinks.removeClass("active");
                    $this.addClass("active");
                    self.$animatingScroll = false;
                    self.scrollToActiveAnchorMenuItem($this);
                });
            }
        });
        
        var topMenu = $(".navbar");
        self.$topMenuHeight = self.$anchorMenuWrapper.outerHeight() + topMenu.outerHeight() + 15;
        // Anchors corresponding to menu items
        self.$scrollItems = self.$anchorLinks.map(function () {
            var item = $($('a', this).attr("href"));
            if (item.length) { return item; }
        });

        //// Bind to scroll
        $(window).scroll(function () {
            if (!self.$animatingScroll) {
                self.setActiveAnchor();
            }
        });
    },

    setActiveAnchor: function () {
        var self = this;

        // Get container scroll position
        var fromTop = $(window).scrollTop() + self.$topMenuHeight;

        // Get id of current scroll item
        var cur = self.$scrollItems.map(function () {
            if ($(this).offset().top <= fromTop)
                return this;
        });

        // Get the id of the current element
        cur = cur[cur.length - 1];

        var activeElement;
        if (cur && cur.length) {
            var id = cur && cur.length ? cur[0].id : "";
            activeElement = $("[href*='#" + id + "']").parent();
        } else {
            activeElement = $(self.$anchorLinks[0]);
        }

        if (!activeElement.hasClass("active")) {
            self.$anchorLinks.removeClass("active");
            activeElement.addClass("active");
            self.scrollToActiveAnchorMenuItem(activeElement);
        }
    },

    scrollToActiveAnchorMenuItem: function (activeElement) {
        this.$anchorMenuInner.animate({
            scrollLeft: activeElement.offset().left
        }, 250);
    },

    updateAnchorMenuWidth: function () {
        if (this.$win.width() - 70 < this.$anchorMenuList.width()) {
            this.$anchorMenuWrapper.addClass('scrollable');
        } else {
            this.$anchorMenuWrapper.removeClass('scrollable');
        }
    },

    getAnchors: function () {
        this.$html = $('html');
        var articles = $('#main > div > article[data-name]:not(#hero):not(.inpagemenuholder-block)');
        var anchors = [];
        var nameAttribute = this.$html.hasClass("touch") ? "data-mobile-name" : "data-name";
        for (var i = 0; i < articles.length; i++) {
            var name = typeof (articles[i]) !== 'undefined' ?
                articles[i].getAttribute(nameAttribute) !== undefined ?
                    articles[i].getAttribute(nameAttribute) : '' : '';
            if (name !== undefined && name != null && name.length > 0) {
                anchors.push({
                    id: articles[i].getAttribute('id'),
                    name: name
                });

            }
        }
        return anchors;
    }
};
